import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Box, Text } from '@atlaskit/primitives';

const i18n = defineMessages({
	comingSoon: {
		id: 'audio.audio-briefing-popup.customize-tab.coming-soon',
		defaultMessage: 'Coming soon',
		description: 'Text to inform users that the customization feature will be available soon',
	},
});

export const AudioBriefingPopupCustomizePanel = () => {
	const { formatMessage } = useIntl();

	return (
		<Box>
			<Text>{formatMessage(i18n.comingSoon)}</Text>
		</Box>
	);
};
